import {PlantaState} from './types'
export const state: PlantaState={
    plantas!:[]
}